export default {
  buttons: {
    continue: "Pokračovat",
    back: "Zpět",
    backToPaths: "Přehled kurzů",
    replayPath: "Začít kurz",
    backToJourney: "Zpět do kurzu",
    viewFullLesson: "Zobrazit plný kurz",
    buy: "Koupit",
    analyzeJourney: "Analyzovat kurz",
    regenerateAnalysis: "Přegenerovat analýzu",
    showJourneyAnalysis: "Zobrazit analýzu kurzu",
    downloadPdf: "Stáhnout v PDF",
  },
  messages: {
    finish: "Úspěšně jste dokončili kurz:",
    stepLocked: "Tento krok je uzamčený.",
    initiated: "Spotřebovali jste {credits} kreditů",
    generateAnalysisFirst: "Nejprve prosím vygenerujte analýzu.",
  },
  notifications: {
    generatingAnalysis: "Generuji analýzu kurzu. Budete informováni, až se analýza dokončí.",
    analysisReady: "Analýza kurzu je připravena!",
  },
  titles: {
    learningPath: "Kurz",
    finish: "Blahopřejeme!",
    analysis: "Analýza vašeho kurzu",
    keyTakeaways: "Hlavní body",
    strengths: "Silné stránky",
    weaknesses: "Oblasti pro zlepšení",
    completionOverview: "Přehled dokončení kurzu",
    exerciseCompletion: "Dokončení cvičení",
    exercises: "Cvičení",
    noLessonAnalysisFound: "Nebyla nalezena žádná analýza kurzu",
    exerciseDescription: "Popis cvičení",
  },
  gameHistoryList: {
    name: "Název",
    type: "Typ",
    startedAt: "Započato",
    endedAt: "Dokončeno",
    status: "Stav",
    userInfo: "Informace o uživateli",
    userName: "Jméno",
    lessonCompletion: "Dokončení kurzu",
  },
};
